export const EXPAND_ALL = 0;
export const COLLAPSE_ALL = 1;
export const EXPAND_INDIVIDUAL_SETTING_ONLY = 2;

export const MOBILE_ORDER_DISPLAY_ALL = 0;
export const MOBILE_ORDER_DISPLAY_ONLY_EDITED = 1;

export const CONSISTENCY_CHECK_SOURCE: { [key: string]: { [key: string]: string } } = {
  jp: {
    0: '全て表示',
    1: 'なしのみ表示',
    2: 'ありのみ表示',
  },
  en: {
    0: 'Show all',
    1: 'None only',
    2: 'Only',
  },
};

export const NG_NUMBER_CHECK_SOURCE: { [key: string]: { [key: string]: string } } = {
  jp: {
    0: '全て表示',
    1: 'OKのみ表示',
    2: 'NGのみ表示',
  },
  en: {
    0: 'ALL',
    1: 'OK',
    2: 'NG',
  },
};

export const ASSIGNED_STATUS_ALL = '0';
export const ASSIGNED_STATUS_ASSIGNED_SUBGENRE = '1';
export const ASSIGNED_STATUS_NOT_ASSIGNED_SUBGENRE = '2';
